import { RemoveSnack as StartRemoveSnack, SnackId } from "./snack"
import type { SnackAddState, SnackType } from "./snack"

import type { SYSAction } from "../../"
import { html, render, unsafeHTML } from "../../"
import type { TemplateResult } from "../../"
import { _RenderTracking } from "../../tracker/tracker"

export const _RemoveSnack: SYSAction<string> = (value, { global }) => {
  let state = global.getState()
  // if not already got added just remove from state (there are max. 3 snacks display so it could be that its not even displayed)
  let key = "ovlsnack" + value.replaceAll(".", "_").replaceAll(",", "_")
  if (
    state.ovl.libState.snacks[key] &&
    state.ovl.libState.snacks[key].status === "queued"
  ) {
    delete state.ovl.libState.snacks[key]
    return
  }
  let el = document.querySelector(`#${key}:not(.fadeOutSnack)`)
  // problem it removes the one with animation fadeout, it should use the one without

  if (!el) {
    el = document.querySelector(`#${key}`)
  }
  StartRemoveSnack(el)
}

export const _ClearSnack: SYSAction<{ id: string; el: any }> = (
  value,
  { global },
) => {
  let state = global.getState()
  let actions = global.getActions()
  delete state.ovl.libState.snacks[
    value.id.replaceAll(".", "_").replaceAll(",", "_")
  ]

  let el = value.el
  if (el) {
    let parent = el
    // parent.removeChild(el)
    do {
      //@ts-ignore
      let parent2 = parent.previousElementSibling
      if (!parent2) {
        break
      }
      let parentFirstChild = parent2.firstElementChild
      if (
        !parentFirstChild ||
        parentFirstChild.classList.contains("fadeInSnack") ||
        parentFirstChild.classList.contains("fadeOutSnack")
      ) {
        break
      }

      parent.appendChild(parentFirstChild)
      parent = parent2
    } while (true)
    actions.ovl.internal._PlaceSnack()
  }
}

export type ReplaceSnackContentType = {
  content: string | TemplateResult
  key: string
}

export const _ReplaceSnackContent: SYSAction<ReplaceSnackContentType> = (
  content,
  { global },
) => {
  let state = global.getState()
  let ovlContentEl = document.getElementById(
    `ovlsnack${content.key.replaceAll(".", "_").replaceAll(",", "_")}content`,
  )
  if (!ovlContentEl) {
    return
  }
  let text = content.content
  if (typeof text === "string") {
    text = text.replace(/\r?\n/, "<br />")
  }
  //@ts-ignore
  ovlContentEl.innerHTML = text
}

export const _PlaceSnack: SYSAction = (_, { global }) => {
  let state = global.getState()
  let ovlSnackEl = document.getElementById("ovlsnack")
  let wait = 0
  ovlSnackEl = document.getElementById("ovlsnack")
  if (!ovlSnackEl) {
    return
  }
  let snacks = state.ovl.libState.snacks
  if (snacks) {
    Object.keys(snacks)
      .filter((f) => snacks[f].status === "queued")
      .sort((a, b) => snacks[a].id - snacks[b].id)
      .forEach((k) => {
        //if (filteredAndSortedSnacks.length > 0) {
        let snackToAdd = snacks[k]
        let lastOccupiedSlot = 0
        let lastFreeSlot = 0
        let lastFreeSlotEl
        let firstFreeSlotEl
        let parentEl = ovlSnackEl.lastElementChild
        let z = 0
        do {
          let slotEl = parentEl.firstElementChild
          if (slotEl) {
            lastOccupiedSlot = z
          } else {
            lastFreeSlot = z
            lastFreeSlotEl = parentEl
            if (!firstFreeSlotEl) {
              firstFreeSlotEl = parentEl
            }
          }
          parentEl = parentEl.previousElementSibling
          z++
        } while (parentEl)
        if (lastOccupiedSlot === 0 || lastOccupiedSlot < lastFreeSlot) {
          if (lastOccupiedSlot === 0) {
            lastFreeSlotEl = firstFreeSlotEl
          }

          snackToAdd.status = "running"
          let snackType
          let busyIndicator
          if (snackToAdd.type === "BusyIndicator") {
            snackType = "Information".toLowerCase() as SnackType
            busyIndicator = html`<div
              class="fd-busy-indicator--m"
              aria-hidden="false"
              aria-label="Loading"
            >
              <div class="fd-busy-indicator--circle-0"></div>
              <div class="fd-busy-indicator--circle-1"></div>
              <div class="fd-busy-indicator--circle-2"></div>
            </div>`
          }

          snackType = snackToAdd.type.toLowerCase()
          let div = document.createElement("div")
          div.id = k
          div.setAttribute("role", "alert")
          if (typeof snackToAdd.text === "string") {
            snackToAdd.text = unsafeHTML(snackToAdd.text)
          }
          let content = html`<div id=${k + "content"}>${snackToAdd.text}</div>`
          let cancelBtn = snackToAdd.cancelable
            ? html` <span
                class="sap-icon--decline ovl-snack-cancel"
                @click=${(e) => {
                  e.stopPropagation()
                  if (snackToAdd.onCancel) snackToAdd.onCancel()
                }}
              ></span>`
            : html``
          let tpl
          if (busyIndicator) {
            tpl = html`<div class="ovl-snack-container">
              <div class="ovl-snack-content-with-indicator">
                ${content} &nbsp; &nbsp; ${busyIndicator}
              </div>
              ${cancelBtn}
            </div>`
          } else {
            tpl = html`<div class="ovl-snack-container">
              ${content} ${cancelBtn}
            </div>`
          }
          render(tpl, div)
          div.classList.add("fd-message-strip")
          div.classList.add("ovl-snack")
          let type = "fd-message-strip--" + snackType
          div.classList.add(type)
          div.classList.add("fadeInSnack")
          lastFreeSlotEl.appendChild(div)
          if (snackToAdd.durationMs != 999999) {
            setTimeout((e) => {
              StartRemoveSnack(div)
            }, snackToAdd.durationMs)
          }
        }
      })
  }
  //}, wait)
}

export const _AddSnack: SYSAction<SnackAddState> = (value, { global }) => {
  _RenderTracking.pauseTracking = true
  try {
    let state = global.getState()
    let actions = global.getActions()
    // don't stack unecessary fire and forget notifications when tab is not active...
    if (!value.key && document.hidden) {
      return
    }
    let id = SnackId.id++
    let key = value.key
    if (!key) {
      key = "ovlsnack" + id.toString()
    }
    if (!key.startsWith("ovlsnack")) {
      key = "ovlsnack" + key
    }
    key = key.replaceAll(".", "_").replaceAll(",", "_")
    let duration = value.durationMs
    if (!duration) {
      duration = 4000
    }

    let text = value.text
    if (typeof text === "string") {
      text = text.replace(/\r?\n/, "<br />")
    }

    if (!state.ovl.libState.snacks[key]) {
      state.ovl.libState.snacks[key] = {
        text,
        type: value.type,
        durationMs: duration,
        status: "queued",
        id,
        key,
        cancelable: value.cancelable,
        onCancel: value.onCancel,
      }
      actions.ovl.internal._PlaceSnack()
    }
  } finally {
    _RenderTracking.pauseTracking = false
  }
}

// removed in favour of ProcessIsRunning...
// export const SnackTrackedIsRunning = (key: string) => {
//   return !!ovl.getState().ovl.libState.snacks[`ovlsnack${key}`]
// }
